import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import "./NotificationPopup.css";
import NewApplicationIcon from "../../Assets/Images/new-application-icon.svg";
import { formatNotificationBody } from "../../Common/Common-Function/CommonFunctions";

const NotificationPopup = ({
  isOpen,
  onClose,
  notifications,
  unreadCount,
  onMarkAllRead,
  onNotificationClick,
  isDarkMode,
}) => {
  const [filteredNotifications, setFilteredNotifications] = useState([]);
  const popupRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!notifications) return;
    let filtered = [...notifications];
    setFilteredNotifications(filtered);
  }, [notifications]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        onClose();
      }
    };
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  const timeAgo = (timestamp) => {
    return moment(timestamp).fromNow();
  };

  const getNotificationIcon = (type) => {
    switch (type) {
      case "application_received":
        return (
          <img
            src={NewApplicationIcon}
            alt="New application"
            className="notification-application-icon"
          />
        );
      default:
        return "🔔";
    }
  };

  if (!isOpen) return null;

  return (
    <div className="notification-popup-overlay">
      <div
        ref={popupRef}
        className={`notification-popup ${isDarkMode ? "dark" : "light"}`}
      >
        <div className="notification-popup-header">
          <div className="header-left">
            <h3>Notifications</h3>
            <span className="unread-badge">{unreadCount || 0}</span>
          </div>
        </div>
        <div className="notification-list">
          {filteredNotifications.length === 0 ? (
            <div className="empty-notifications">
              <span className="empty-icon">🔔</span>
              <p>No notifications yet</p>
              <span className="empty-subtext">
                We'll notify you when something happens
              </span>
            </div>
          ) : (
            filteredNotifications.map((notification) => (
              <div key={notification.id} className="notification-item">
                <div className="notification-icon">
                  <span>{getNotificationIcon(notification.type)}</span>
                </div>
                <div className="notification-content">
                  <div className="notification-title">{notification.title}</div>
                  <div className="notification-body">
                    {formatNotificationBody(notification.body)}
                  </div>
                  {notification.data?.job_title && (
                    <div className="notification-meta">
                      <span className="job-title">
                        {notification.data.job_title}
                      </span>
                      {notification.data?.candidate_name && (
                        <>
                          <span className="meta-separator">•</span>
                          <span className="candidate-name">
                            {notification.data.candidate_name}
                          </span>
                        </>
                      )}
                    </div>
                  )}
                  <div className="notification-time">
                    {timeAgo(notification.created_at)}
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
        {filteredNotifications.length > 0 && (
          <div className="notification-footer">
            <span
              className="view-all-btn"
              onClick={() => {
                navigate("/notifications");
                onClose();
              }}
            >
              View all notifications
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default NotificationPopup;
